export default "__VITE_ASSET__Dq78YsBI__"